import { Injectable } from '@angular/core';

export enum Stage {
  LOCAL = 'local',
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

@Injectable({
  providedIn: 'root',
})
export class EnvService {
  public production;
  public API_BASE_PATH;
  public CLIENT_ID;
  public CLIENT_SECRET;
  public version;
  public logoName;
  public cloudfrontUrl;
  public stage;
  public other_reports_link;
  public other_reports_impersonation_link;

  constructor() {}
}
